import { render, staticRenderFns } from "./DownFile.vue?vue&type=template&id=4bac11a3&scoped=true&"
import script from "./DownFile.vue?vue&type=script&lang=js&"
export * from "./DownFile.vue?vue&type=script&lang=js&"
import style0 from "./DownFile.vue?vue&type=style&index=0&id=4bac11a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac11a3",
  null
  
)

export default component.exports